<template>
  <div class="organisationAnalytics-page pa-6">
    <p-progress-linear v-if="isLoading" :indeterminate="true" color="base" height="10">
    </p-progress-linear>
    <p-container v-if="!isLoading">
      <!-- Title -->
      <h2 class="mb-4">
        <p-button tertiary @click="$router.back()">
          <p-icon>keyboard_backspace</p-icon>
        </p-button>
        {{ $t('page.dashboard.organisations.zahlen.title') }}
      </h2>
      <p-row>
        <!-- Search Field -->
        <p-col xs12 md6 lg3>
          <p-text-field v-model="page.organisationAnalytics.filter.searchCriteria" clearable :label="$t('core.app.search')" context-icon="search"></p-text-field>
        </p-col>
        <!-- Event Filter -->
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.eventsDataSource.filter.eventIdentifier"
            :label="$t('page.events.select.eventName')"
            :items="page.eventItems"
            @input="page.refreshAnalytics()"
          ></p-select>
        </p-col>
      </p-row>
      <p-list-view
        v-model="page.organisationsAnalyticsList"
        :pagination.sync="page.organisationAnalytics.paging"
        :columns="page.companyColumns"
      >
        <template slot="table-actions">
          <!-- Refresh Button -->
          <p-button :disabled="isLoading" @click="page.refreshAnalytics()">
            <p-icon>refresh</p-icon>
          </p-button>
        </template>
        <template #actions="{ row }">
          <p-col v-if="hasAnalytics(row.values)" xs12 sm6 md10>
            <p-row dense>
              <p-col xs6>
                <p-button @click="page.gotoDetail(row.values.companyId)">
                  <p-icon>arrow_forward</p-icon>
                </p-button>
              </p-col>
            </p-row>
          </p-col>
        </template>
      </p-list-view>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import { IDataSourcePaging } from '@glittr/frontend-core/src/core/v2/data/data-source';
  import OrganisationAnalyticsPage from './analytics.vue.model';

  export default Vue.extend({
    name: 'OrganisationAnalytics',
    auth: true,
    data: () => ({
      page: new OrganisationAnalyticsPage(),
      isLoading: false,
      innerPagination: {} as IDataSourcePaging,
    }),
    computed: {
      isAdmin(): boolean {
        let isAdmin = false;
        if (this.$auth.isLoggedIn) {
          isAdmin = this.$auth.isInRole('Admin', 'HostAdmin');
        }
        return isAdmin;
      },
    },
    watch: {
      'page.dataSource.paging': {
        handler() {
          this.innerPagination = this.page.dataSource.paging;
        },
      },
    },
    async beforeMount() {
      this.isLoading = true;
      this.page.initialize();
      this.isLoading = false;
    },
    methods: {
      onPaginationChange() {
        this.$debounce(() => {
          this.page.dataSource.paging = this.innerPagination;
        }, 500, this)();
      },
      hasAnalytics(values: any): boolean {
        return (
          (values.countShowDetails ?? 0) > 0
          || (values.countAddToTour ?? 0) > 0
          || (values.countRemoveFromTour ?? 0) > 0
          || (values.countDownloadTour ?? 0) > 0
        );
      },

    },
  });
</script>
